import ac from 'argument-contracts';
import {
    DEFAULT_KEY_METRIC,
    isValidKeyMetric
} from '../../key-metric';

/**
 * A class to represent the visualization options for a document column
 *
 * @param {object} options - options object (See below)
 * @param {string|DEFAULT_KEY_METRIC} [options.keyMetric=DEFAULT_KEY_METRIC] - The key metric to display on the card
 * @param {string} [options.language='en'] - The language to use for translating labels
 * @param {string} [options.yAxisTitle] The label for value being measured, if one was provided.
 */
export class DocumentColumnOptions {
    constructor({
        keyMetric = DEFAULT_KEY_METRIC,
        language = 'en',
        yAxisTitle
    } = {}) {
        ac.assertObject(arguments[0], 'options');

        if(!isValidKeyMetric(keyMetric) && typeof keyMetric !== 'string') {
            throw new RangeError(`options.keyMetric must be a valid KeyMetric value or string. Provided value: ${keyMetric}`);
        }

        const languageNames = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });
        if (languageNames.of(language) === undefined) {
            throw new RangeError(`options.language must be a valid ISO language code. Provided value: ${language}`);
        }

        if(yAxisTitle !== undefined) {
            ac.assertString(yAxisTitle, 'options.yAxisTitle');
        }

        this.keyMetric = keyMetric;
        this.language = language;
        this.yAxisTitle = yAxisTitle;

        Object.freeze(this);
    }
}
